// extracted by mini-css-extract-plugin
module.exports = {"rateCell":"ExpandedView_rateCell__2nAz5","text":"ExpandedView_text__3FAwE","cellPadding":"ExpandedView_cellPadding__c6OO4","namecellPadding":"ExpandedView_namecellPadding__3q5jd"};